<template>
  <fy-form :model="form_info" :rules="rules" class="fy-form-login-pc" ref="form" v-if="!isInit">
    <div class="wrap1920" id="indexContent">
      <div class="wrap" style="margin: auto;">
        <div class="tourism_main">
          <div class="logonLeft">
            <img src="../../assets/images/upload/cache_image/default/octweb2000-1-1-/logon02.jpg">
          </div>
          <div class="logonRight">
            <p>
              <img src="@/assets/images/html/logon01.jpg">
            </p>
            <div class="pw_nav">
              <i>1.确认帐号 ></i>
              <i>2.安全验证 ></i>
              <i>3.设置密码</i>
            </div>
            <div class="pw_set_up">
              <p class="p2">
                <em></em>
                <fy-form-item :inner_width="'100%'" :prop="fields.passwd.field_enname">
                  <fy-input
                    :placeholder="fields.passwd.field_placeholder"
                    type="password"
                    v-model.trim="form_info.passwd"
                  ></fy-input>
                </fy-form-item>
              </p>
              <p class="p2">
                <em></em>
                <fy-form-item :inner_width="'100%'" :prop="fields.confirmPasswd.field_enname">
                  <fy-input
                    :placeholder="fields.confirmPasswd.field_placeholder"
                    type="password"
                    v-model.trim="form_info.confirmPasswd"
                  ></fy-input>
                </fy-form-item>
              </p>
              <div>
                <input
                  @click="validatepasswd()"
                  class="submitBtn"
                  name="find_passwd2"
                  type="button"
                  value="确认提交"
                >
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </fy-form>
</template>
<script>
export default {
  name: 'FindPasswd3',
  componentName: 'FindPasswd3',
  data () {
    return {
      url: 'member/find_passwd3',
      form_info: {
        username: '',
        code: '',
        passwd: '',
        confirmPasswd: ''
      },
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
      fields: {},
      rules: {}
    }
  },
  created () {
    const username = this.$sessionStorageUtil.get('find_passwd_username')
    const code = this.$sessionStorageUtil.get('find_passwd_code')
    if (username && code) {
      this.form_info.username = username
      this.form_info.code = code
      this.$pageField.init(this, 'fields', 'findPasswd3').then(res => {
        this.isInit = false //异步加载完成后设置为true
        this.rules.confirmPasswd[0].confirmProp = 'passwd'
      })
    } else {
      this.$msg('参数错误或过期，回到找回密码步骤1页面，重新填写手机号码！', 'error')
      this.$pushByName('findPasswd')
    }
  },
  methods: {
    validatepasswd () {
      this.$refs.form.validate((valid, invalidFields) => {
        if (valid) {
          var loading = this.$loadingIndicator.eleOpen('信息审核中...')
          this.$myPut(this.url, this.form_info).then(res => {
            const rcode = res.response.data.rcode
            if (rcode == 0) {
              this.$sessionStorageUtil.remove('find_passwd_username')
              this.$sessionStorageUtil.remove('find_passwd_code')
              this.$pushByName('login')
              this.$sessionStorageUtil.set('next_message', '已成功找回密码', 60 * 5)
              loading.close()
            } else {
              if (rcode == 1025) {
                this.$sessionStorageUtil.set('next_message', res.response.data.messages[0].msg + ',回到修改密码步骤1重新操作！', 60 * 5)
                this.$sessionStorageUtil.set('next_message_type', 'error')
                this.$pushByName('findPasswd')
                loading.close()
              } else if (rcode == 1015) {
                this.$sessionStorageUtil.set('next_message', res.response.data.messages[0].msg + ',回到修改密码步骤2重新操作！', 60 * 5)
                this.$sessionStorageUtil.set('next_message_type', 'error')
                this.$pushByName('findPasswd2')
                loading.close()
              } else {
                loading.close()
                this.$msg(res.response.data.messages[0].msg + ',回到修改密码步骤1重新操作！', 'error')
              }
            }
          }).catch(err => {
            loading.close()
            this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
          })
        } else {
          this.$msg(invalidFields[0].message, 'error')
        }
      })
    }
  }
}
</script>
<style scoped>
@import '../../assets/css/pages/user/user.css';
@import '../../assets/css/pages/customer/css.css';
</style>



// WEBPACK FOOTER //
// src/pages/user/findPasswd3.vue